import React from 'react'
import {Button, ButtonToolbar} from 'react-bootstrap'
import {find, last} from 'lodash'

import * as feedbackService from '../../services/feedback-service'

import Question from '../../components/Question'
import {buildAnswerMap} from '../../utils'
import ConfirmModal from '../../components/ConfirmModal'
import {NotificationManager} from 'react-notifications'

export default class FeedbackPage extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.handleChange = this.handleChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.showConformModal = this.showConformModal.bind(this)
    this.cancelSubmit = this.cancelSubmit.bind(this)
    this.state = {
      scan: {locationName: '', organizationalUnitName: ''},
      questions: {coreQuestions: [], extraQuestions: []},
      uuid: this.props.match.params.uuid ? this.props.match.params.uuid : '',
      isValidUUID: false,
      isTokenExpired: false,
      isExtraQuestionsEnabled: false,
      isSubmit: false,
      confirmModal: false,
      message: ''
    }
  }

  componentDidMount() {
    const validUUID = (id) => /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/.test(id)
    const uuid = this.state.uuid

    if (validUUID(uuid)) {
      Promise.all([feedbackService.getFeedbackScan(uuid),
        feedbackService.getFeedbackQuestions(uuid),
        feedbackService.getFeedbackAnswers(uuid)])
        .then(([scan, questions, answers]) => {
          this.setState({
            ...this.state,
            isValidUUID: true,
            isExtraQuestionsEnabled: questions.extraQuestionsEnabled,
            scan,
            questions,
            answers
          })
        })
        .catch(() => {
          this.setState({
            ...this.state,
            isTokenExpired: true
          })
        })
    }
  }

  getCoreQuestions(coreQuestions, answers, completed, questions) {
    return (<div className="feedback-core-questions scan-container">
      <h2>Vragen</h2>
      {coreQuestions.map((core, index) => (
        <div className="scan-section" key={'core' + index}>
          {core.questions.map((question, i) => (
            <Question
              key={index + '-' + i}
              question={question}
              onChange={this.handleChange}
              state={answers}
              completed={completed}
              isIntroQuestions={true}
              feedback={true}
              answermap={buildAnswerMap(questions, answers)}
            />
          ))}
        </div>
      ))}
    </div>)
  }

  getExtraQuestions(extraQuestions, answers, completed, questions) {
    return (<div className="feedback-extra-questions scan-container">
      <h2>Extra vragen</h2>
      {extraQuestions.map((question, i) => (
        <Question
          key={'extravraag-' + i}
          question={question}
          onChange={this.handleChange}
          state={answers}
          completed={completed}
          isIntroQuestions={true}
          answermap={buildAnswerMap(questions, answers)}
        />))}
    </div>)
  }

  handleChange(e, values, save) {
    let answers = this.state.answers
    let type = e.target.type
    const uuid = this.props.match.params.uuid

    let promises = []
    if (type === 'radio') {
      const optionId = parseInt(e.target.value, 10)

      // Update all others too
      for (let i = 0; i < values.length; i++) {
        const booleanValue = values[i] === optionId

        promises.push(feedbackService.upsertFeedbackAnswer(uuid, {optionId: values[i], booleanValue}))

        let answer = find(answers, a => a.optionId === values[i])
        if (!answer) {
          answer = {uuid, optionId: values[i]}
          answers.push(answer)
        }
        answer.booleanValue = booleanValue
      }
    } else if (type === 'checkbox') {
      const optionId = parseInt(e.target.value, 10)
      const booleanValue = e.target.checked

      promises.push(feedbackService.upsertFeedbackAnswer(uuid, {optionId, booleanValue}))

      let answer = find(answers, a => a.optionId === optionId)
      if (!answer) {
        answer = {uuid, optionId}
        answers.push(answer)
      }

      const lastOptionId = last(values)
      if (lastOptionId === optionId) {
        const rest = values.slice(0, -1)

        for (let i = 0; i < rest.length; i++) {
          promises.push(feedbackService.upsertFeedbackAnswer(uuid, {optionId: rest[i], booleanValue: false}))

          let restAnswer = find(answers, a => a.optionId === rest[i])

          if (!restAnswer) {
            restAnswer = {uuid, optionId: rest[i]}
            answers.push(restAnswer)
          }
          restAnswer.booleanValue = false
        }
      } else {
        promises.push(feedbackService.upsertFeedbackAnswer(uuid, {optionId: lastOptionId, booleanValue: false}))

        let lastAnswer = find(answers, a => a.optionId === lastOptionId)
        if (!lastAnswer) {
          lastAnswer = {uuid, optionId, booleanValue: false}
          answers.push(lastAnswer)
        }
        lastAnswer.booleanValue = false
      }
      answer.booleanValue = booleanValue
    } else {
      const optionId = values
      promises.push(feedbackService.upsertFeedbackAnswer(uuid, {optionId, stringValue: e.target.value}))

      let answer = find(answers, a => a.optionId === optionId)
      if (!answer) {
        answer = {uuid, optionId}
        answers.push(answer)
      }
      answer.stringValue = e.target.value
    }

    Promise.all(promises)
      .then(() => {
        this.setState(...this.state, {answers, status: 'OK', message: 'Antwoord opgeslagen'})
      })
      .catch(reason => {
        this.setState(...this.state, {status: 'ERROR', message: 'Antwoord kon niet opgeslagen worden, ' + reason})
      })
      .finally(() => {
        if (this.state.status === 'ERROR') {
          NotificationManager.error(this.state.message)
        }
      })

  }

  showConformModal() {
    this.setState({confirmModal: true})
  }

  onSubmit() {
    this.setState({...this.state, isSubmit: true, confirmModal: false})

    feedbackService.deleteFeedback(this.state.uuid)
      .then(() => {
        this.setState(...this.state, {status: 'OK', message: 'Feedbackpagina verwijderd'})
      })
      .catch(() => {
        this.setState(...this.state, {status: 'ERROR', message: 'Feedbackpagina kon niet verwijderd worden'})
      })
      .finally(() => {
        if (this.state.status === 'ERROR') {
          NotificationManager.error(this.state.message)
        }
      })
  }

  cancelSubmit() {
    this.setState({confirmModal: false})
  }

  render() {
    const {isValidUUID, isTokenExpired, answers, questions, isExtraQuestionsEnabled, isSubmit, scan} = this.state
    const {coreQuestions, extraQuestions} = questions
    const completed = false

    return (<div className="feedback-main">
        {isTokenExpired ?
          (<div className="feedback-inner"><h2>Let op!</h2>
            <hr/>
            <p>Token verlopen</p></div>) :

          isValidUUID ?

            isSubmit ?

              (<div className="feedback-inner"><h2>Bedankt!</h2>
                <hr/>
                <p>Bedankt voor het invullen van de vragenlijst. Uw antwoorden zijn verstuurd.</p></div>) :

              (<div className="feedback-inner">
                <div className="feedback-header">
                  <div className="title">{scan.locationName}</div>
                  <div className="sub-title">{scan.organizationalUnitName}</div>
                </div>
                <div className="feedback-intro">
                  <p>Beantwoord de volgende vragen specifiek voor bovenstaande locatie en eenheid. Vragen waarop je het
                    antwoord niet weet, mag je overslaan.</p>
                </div>
                {this.getCoreQuestions(coreQuestions, answers, completed, questions)}
                {isExtraQuestionsEnabled && this.getExtraQuestions(extraQuestions, answers, completed, questions)}

                <ButtonToolbar>
                  <Button bsStyle="primary" onClick={this.showConformModal}>Voltooien</Button>
                </ButtonToolbar>
              </div>) :

            (<div className="feedback-inner"><h2>Let op!</h2>
              <hr/>
              <p>Geen toegang</p></div>)
        }
        <ConfirmModal
          title="Antwoorden versturen"
          body={`Weet u zeker dat u uw antwoorden wilt versturen? U kunt uw ingevulde antwoorden niet meer wijzigen.`}
          show={this.state.confirmModal}
          onHide={this.cancelSubmit}
          onSubmit={this.onSubmit}
          confirmbuttontext="Versturen"/>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/Feedback/index.js